import { Component, OnInit, inject, signal, effect } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from '@shared/services/auth.service';
import { ThemeService } from '@shared/services/theme.service';
import { LoadingPageComponent } from '@shared/components/loading-page/loading-page.component';
import { ModalStackService } from '@shared/services/modal/modal-stack.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    LoadingPageComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'Eternity';
  isLoading = signal(true);
  showLoadingComponent = signal(true); // Controla si el componente está en el DOM

  private authService = inject(AuthService);
  private router = inject(Router);
  private modalStack = inject(ModalStackService);
  
  ngOnInit() {
    // Token recovery is handled by APP_INITIALIZER (app.config.ts) before this
    // component initializes. No localStorage token hydration needed here.

    // Limpiar overflow del body en cada cambio de ruta como medida de seguridad
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Si no hay modales abiertos pero el body tiene overflow hidden, limpiarlo
      const modalsCount = this.modalStack.getOpenModalsCount();
      if (modalsCount === 0 && document.body.style.overflow === 'hidden') {
        console.warn('[AppComponent] Limpiando overflow residual en cambio de ruta');
        document.body.style.overflow = '';
      }
    });

    // Exponer funciones de debugging en desarrollo
    if (typeof window !== 'undefined') {
      (window as any)['modalStackDebug'] = () => this.modalStack.getDebugInfo();
      (window as any)['modalStackReset'] = () => this.modalStack.reset();
    }

    // Simular tiempo de carga y ocultar el loading cuando la página esté lista
    // Esperar a que el contenido se cargue
    if (document.readyState === 'complete') {
      this.hideLoading();
    } else {
      window.addEventListener('load', () => {
        this.hideLoading();
      });
    }
  }

  private hideLoading() {
    // Pequeño delay para una transición suave
    setTimeout(() => {
      this.isLoading.set(false);
      setTimeout(() => {
        this.showLoadingComponent.set(false);
      }, 800);
    }, 500);
  }
}
